// extracted by mini-css-extract-plugin
export default {"componentWrapper":"DefaultLayout_componentWrapper__J7E23","logo":"DefaultLayout_logo__DxMIB"};